import { render, staticRenderFns } from "./SignupForm.vue?vue&type=template&id=038645c6&scoped=true&"
import script from "./SignupForm.vue?vue&type=script&lang=js&"
export * from "./SignupForm.vue?vue&type=script&lang=js&"
import style0 from "./SignupForm.vue?vue&type=style&index=0&id=038645c6&scoped=true&lang=css&"
import style1 from "./SignupForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038645c6",
  null
  
)

export default component.exports